import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Spacious 2, 3 & 4 BHK Residences",
    "Prime Location at GTB Nagar, Mumbai",
    "Trusted Rustomjee Quality and Craftsmanship",
    "Modern Lifestyle Amenities for All Ages",
  ];
  const highlights2 = [
    "Excellent Connectivity to City Hotspots",
    "Smart Layouts with Premium Finishes",
    "Surrounded by Schools, Malls, Hospitals",
    "Early Launch Offers for First Movers",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Introducing an extraordinary living experience in the heart of Guru Teg
        Bahadur Nagar — Rustomjee’s latest residential masterpiece is coming
        soon. Crafted with the signature elegance and innovation that defines
        the Rustomjee brand, this premium development will offer spacious 2, 3,
        and 4 BHK luxury residences designed for modern urban lifestyles.
        <br />
        Perfectly located in one of Mumbai’s most connected and culturally rich
        neighborhoods, the project promises seamless connectivity, best-in-class
        amenities, and thoughtful architecture. Whether you’re a homebuyer or
        investor, this is an opportunity to be part of a landmark address before
        the rest of the city hears about it.
        <br />
        Limited early access now open — register to be among the first to
        receive pricing, floor plans, and launch offers. Live ahead of the
        curve, live the Rustomjee life.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
